/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Protocol_Generate_TipInputs */

const cs_templates_protocol_generate_tip = /** @type {(inputs: Templates_Protocol_Generate_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol se generuje na úkolu prohlídky (ne ze studia šablon).`)
};

const en_templates_protocol_generate_tip = /** @type {(inputs: Templates_Protocol_Generate_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocols are generated on a viewing task (not from the template studio).`)
};

/**
* | output |
* | --- |
* | "Protocols are generated on a viewing task (not from the template studio)." |
*
* @param {Templates_Protocol_Generate_TipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_protocol_generate_tip = /** @type {((inputs?: Templates_Protocol_Generate_TipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Protocol_Generate_TipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_protocol_generate_tip(inputs)
	return cs_templates_protocol_generate_tip(inputs)
});